import {AccentService} from "../AccentService/AccentService";
import {boldSearchPatterInString} from "../boldSearchPatterInString/boldSearchPatterInString";

export function getMatchingNames(accentService: AccentService, searchedQuery: string, list: string[]): string[] {
    const searchedQueryNormalized = (accentService.normalize(searchedQuery)).toLowerCase();
    const matchingItemsList: string[] = [];

    for (const key in list) {
        const item = list[key];
        const itemNormalized = accentService.normalize(list[key].toLowerCase());

        if (itemNormalized.includes(searchedQueryNormalized)) {
            matchingItemsList.push(item);
        }
    }

    return matchingItemsList;
}

export function getMatchingNamesWithBoldedSearchedPattern(accentService: AccentService, searchedQuery: string, list: string[]): string[] {
    const searchedQueryNormalized = (accentService.normalize(searchedQuery)).toLowerCase();
    const matchingItemsList: string[] = [];

    for (const key in list) {
        const item = list[key];
        const itemNormalized = accentService.normalize(list[key].toLowerCase());

        if (itemNormalized.includes(searchedQueryNormalized)) {
            let itemBolded = boldSearchPatterInString(accentService, searchedQuery, item);
            matchingItemsList.push(itemBolded);
        }
    }

    return matchingItemsList;
}